module.exports = __webpack_public_path__ + "svg/back-white.svg?51629103834b4042878ae6bb60e0f0dc";